// @flow
import React from 'react';
import { colors } from '../constants';

type Props = {
  size: number,
};

const GreenhouseOnboardingWordmark = ({ size }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 530.8 119.01"
      width={size}
    >
      <g fill={colors.evergreen}>
        <path
          d="M33.18,55.37c0,2.37-1,4.47-2.64,6.11c-1.82,1.82-4.47,2.28-4.47,3.83c0,2.1,3.37,1.46,6.61,4.69
		c2.14,2.14,3.46,4.97,3.46,8.25c0,6.47-5.2,11.62-11.71,11.62s-11.71-5.15-11.71-11.62c0-3.28,1.32-6.11,3.46-8.25
		c3.24-3.24,6.61-2.6,6.61-4.69c0-1.55-2.64-2.01-4.47-3.83c-1.64-1.64-2.64-3.74-2.64-6.2c0-4.74,3.87-8.57,8.61-8.57
		c0.91,0,1.73,0.14,2.42,0.14c1.23,0,1.87-0.55,1.87-1.41c0-0.5-0.23-1.14-0.23-1.82c0-1.55,1.32-2.83,2.92-2.83
		c1.6,0,2.87,1.32,2.87,2.92c0,1.69-1.32,2.46-2.32,2.83c-0.82,0.27-1.46,0.64-1.46,1.46C30.35,49.54,33.18,51.04,33.18,55.37z
		 M32.26,78.25c0-4.51-3.33-8.16-7.84-8.16c-4.51,0-7.84,3.65-7.84,8.16c0,4.47,3.33,8.16,7.84,8.16
		C28.94,86.41,32.26,82.72,32.26,78.25z M29.57,55.28c0-2.87-2.32-5.24-5.15-5.24s-5.15,2.37-5.15,5.24s2.32,5.24,5.15,5.24
		S29.57,58.15,29.57,55.28z"
        />
        <path
          d="M49.58,47.17c1.46,0,2.55,1.09,2.55,2.46s-1.05,2.46-2.51,2.46c-1.5,0-2.32-0.96-3.83-0.96
		c-1.46,0-2.6,1.05-2.6,2.83v14.36c0,1.09-0.87,1.96-1.96,1.96c-1.05,0-1.91-0.87-1.91-1.96V48.99c0-1.09,0.87-1.96,1.91-1.96
		c1.96,0,1.6,1.87,3.56,1.87C46.67,48.9,47.35,47.17,49.58,47.17z"
        />
        <path
          d="M53.82,58.65c0-6.88,4.74-11.85,11.26-11.85c5.97,0,10.71,4.38,10.71,10.35c0,1.41-0.91,2.37-2.23,2.37H58.74
		c-0.64,0-0.87,0.23-0.87,0.73c0,1.14,0.91,3.24,2.28,4.6c1.37,1.37,3.24,2.19,5.88,2.19c1.96,0,3.69-0.73,5.01-1.69
		c0.41-0.32,0.87-0.5,1.32-0.5c0.96,0,1.73,0.87,1.73,1.78c0,0.55-0.18,1-0.64,1.41c-1.91,1.6-4.6,2.46-7.52,2.46
		C58.88,70.51,53.82,65.4,53.82,58.65z M69.96,52.09c-1.28-1.28-2.92-1.91-4.88-1.91c-1.96,0-3.78,0.78-5.1,2.1
		c-1.05,1.05-1.78,2.42-1.78,3.33c0,0.46,0.27,0.64,0.87,0.64h11.85c0.55,0,0.82-0.18,0.82-0.64C71.73,54.51,70.87,53,69.96,52.09z"
        />
        <path
          d="M79.71,58.65c0-6.88,4.74-11.85,11.26-11.85c5.97,0,10.71,4.38,10.71,10.35c0,1.41-0.91,2.37-2.23,2.37H84.63
		c-0.64,0-0.87,0.23-0.87,0.73c0,1.14,0.91,3.24,2.28,4.6c1.37,1.37,3.24,2.19,5.88,2.19c1.96,0,3.69-0.73,5.01-1.69
		c0.41-0.32,0.87-0.5,1.32-0.5c0.96,0,1.73,0.87,1.73,1.78c0,0.55-0.18,1-0.64,1.41c-1.91,1.6-4.6,2.46-7.52,2.46
		C84.77,70.51,79.71,65.4,79.71,58.65z M95.84,52.09c-1.28-1.28-2.92-1.91-4.88-1.91c-1.96,0-3.78,0.78-5.1,2.1
		c-1.05,1.05-1.78,2.42-1.78,3.33c0,0.46,0.27,0.64,0.87,0.64H96.8c0.55,0,0.82-0.18,0.82-0.64C97.62,54.51,96.76,53,95.84,52.09z"
        />
        <path
          className="st0"
          d="M124.51,70.28c-1.09,0-1.96-0.87-1.96-1.96v-12.4c0-3.24-2.55-5.7-5.83-5.7c-3.33,0-5.88,2.51-5.88,5.7v12.4
		c0,1.09-0.87,1.96-1.96,1.96c-1.05,0-1.91-0.87-1.91-1.96V48.95c0-1.05,0.87-1.91,1.87-1.91c1.91,0,1.82,1.73,2.83,1.73
		c1,0,2.37-1.96,5.93-1.96c4.97,0,8.84,4.15,8.84,9.12v12.4C126.43,69.41,125.56,70.28,124.51,70.28z"
        />
        <path
          d="M150.67,70.28c-1.09,0-1.96-0.87-1.96-1.96v-12.4c0-3.24-2.55-5.7-5.83-5.7c-3.33,0-5.88,2.51-5.88,5.7v12.4
		c0,1.09-0.87,1.96-1.96,1.96c-1.05,0-1.91-0.87-1.91-1.96V37.6c0-1.09,0.87-1.96,1.91-1.96c1.09,0,1.96,0.87,1.96,1.96v10.07
		c0,0.55,0.23,0.87,0.82,0.87c1,0,2.37-1.73,5.93-1.73c4.97,0,8.84,4.15,8.84,9.12v12.4C152.59,69.41,151.72,70.28,150.67,70.28z"
        />
        <path
          d="M157.92,58.65c0-6.61,5.29-11.85,11.94-11.85c6.66,0,11.94,5.24,11.94,11.85c0,6.61-5.29,11.85-11.94,11.85
		C163.21,70.51,157.92,65.26,157.92,58.65z M177.93,58.65c0-4.6-3.42-8.39-8.07-8.39c-4.6,0-8.02,3.78-8.02,8.39
		c0,4.6,3.42,8.39,8.02,8.39C174.51,67.04,177.93,63.26,177.93,58.65z"
        />
        <path
          d="M189.05,47.03c1.09,0,1.96,0.87,1.96,1.96v12.4c0,3.24,2.55,5.7,5.83,5.7c3.33,0,5.88-2.51,5.88-5.7v-12.4
		c0-1.09,0.87-1.96,1.96-1.96c1.05,0,1.91,0.87,1.91,1.96v19.37c0,1.05-0.87,1.91-1.87,1.91c-1.91,0-1.82-1.73-2.83-1.73
		c-1,0-2.37,1.96-5.93,1.96c-4.97,0-8.84-4.15-8.84-9.12v-12.4C187.13,47.9,188,47.03,189.05,47.03z"
        />
        <path
          d="M213.48,68.82c-0.87-0.55-1.46-1.09-1.46-2.14c0-1,0.77-1.78,1.73-1.78c1.14,0,1.64,0.68,2.6,1.18
		c1.19,0.68,2.55,1.05,4.24,1.05c3.1,0,4.65-1.41,4.65-3.15c0-2.46-2.28-2.92-5.38-3.74c-3.83-1-7.52-2.14-7.52-6.56
		c0-3.92,3.01-6.88,8.34-6.88c2.1,0,4.06,0.55,5.61,1.5c0.55,0.32,1.09,1,1.09,1.78c0,1-0.82,1.87-1.87,1.87
		c-0.68,0-1.23-0.46-1.91-0.91c-0.68-0.46-1.69-0.87-3.05-0.87c-3.05,0-4.38,1.32-4.38,3.1c0,2.33,2.23,2.87,5.42,3.65
		c3.74,0.91,7.43,2.1,7.43,6.61c0,3.92-2.92,6.97-8.52,6.97C217.76,70.51,215.3,69.96,213.48,68.82z"
        />
        <path
          d="M232.67,58.65c0-6.88,4.74-11.85,11.26-11.85c5.97,0,10.71,4.38,10.71,10.35c0,1.41-0.91,2.37-2.23,2.37
		h-14.81c-0.64,0-0.87,0.23-0.87,0.73c0,1.14,0.91,3.24,2.28,4.6c1.37,1.37,3.24,2.19,5.88,2.19c1.96,0,3.69-0.73,5.01-1.69
		c0.41-0.32,0.87-0.5,1.32-0.5c0.96,0,1.73,0.87,1.73,1.78c0,0.55-0.18,1-0.64,1.41c-1.91,1.6-4.6,2.46-7.52,2.46
		C237.73,70.51,232.67,65.4,232.67,58.65z M248.8,52.09c-1.28-1.28-2.92-1.91-4.88-1.91c-1.96,0-3.78,0.78-5.1,2.1
		c-1.05,1.05-1.78,2.42-1.78,3.33c0,0.46,0.27,0.64,0.87,0.64h11.85c0.55,0,0.82-0.18,0.82-0.64C250.58,54.51,249.71,53,248.8,52.09
		z"
        />
      </g>
      <g fill={colors.darkGreenhouseGreen}>
        <path
          d="M281.89,71.42c-9.21,0-15.12-7.17-15.12-17.17c0-9.96,5.91-17.17,15.12-17.17s15.12,7.21,15.12,17.17
		C297.01,64.25,291.1,71.42,281.89,71.42z M281.89,40.47c-7.31,0-11.03,5.77-11.03,13.78c0,8.05,3.72,13.78,11.03,13.78
		c7.26,0,10.98-5.72,10.98-13.78C292.87,46.24,289.15,40.47,281.89,40.47z"
        />
        <path
          d="M307.21,51.73c1.12-2.89,4.05-4.84,7.63-4.84c5.26,0,8.38,3.3,8.38,8.89v15.08h-3.86V56.62
		c0-4.33-1.91-6.56-5.58-6.56c-3.58,0-6.42,2.28-6.42,7.91v12.89h-3.86V47.45h3.72V51.73z"
        />
        <path
          d="M335,70.86h-3.72V36.61h3.86v14.99c1.07-2.37,3.72-4.7,7.77-4.7c5.96,0,10.42,4.84,10.42,12.29
		c0,7.4-4.47,12.24-10.42,12.24c-3.86,0-6.75-2.28-7.91-4.65V70.86z M334.95,59.46c0,5.31,2.61,8.94,7.17,8.94
		c4.61,0,7.31-3.77,7.31-9.21c0-5.49-2.7-9.26-7.31-9.26c-4.56,0-7.17,3.58-7.17,8.89V59.46z"
        />
        <path
          d="M369.34,71.42c-6.47,0-11.12-4.7-11.12-12.24s4.65-12.29,11.12-12.29s11.12,4.75,11.12,12.29
		S375.81,71.42,369.34,71.42z M369.34,68.3c4.56,0,7.31-3.49,7.31-9.12c0-5.63-2.75-9.17-7.31-9.17s-7.31,3.54-7.31,9.17
		C362.04,64.81,364.78,68.3,369.34,68.3z"
        />
        <path
          d="M400.94,66.91c-1.02,2.75-4.24,4.47-8.14,4.47c-4.1,0-7.59-2.37-7.59-6.7c0-4.51,3.35-6.47,8.1-7.03l7.54-0.98
		v-1.35c0-3.72-2.28-5.31-5.49-5.31c-3.12,0-5.07,1.63-5.35,4.33h-3.72c0.46-4.75,4.19-7.45,9.17-7.45c5.68,0,9.21,2.7,9.21,8.33
		v10.75c0,1.72,0.09,3.35,0.56,4.89h-3.86C401.08,69.56,400.94,68.02,400.94,66.91z M400.85,61.65v-2.09l-6.38,0.7
		c-2.93,0.42-5.35,1.16-5.35,4.33c0,2.19,1.54,3.86,4.47,3.86C397.22,68.44,400.85,66.16,400.85,61.65z"
        />
        <path
          d="M425.7,50.66c-0.56-0.14-1.4-0.19-2-0.19c-3.72,0-7.12,2.93-7.12,8.84v11.54h-3.86V47.45h3.72v5.54
		c1.02-3.86,4-6.05,7.45-6.05c0.6,0,1.26,0.05,1.81,0.19V50.66z"
        />
        <path
          d="M446.79,66.77c-1.16,2.37-4.05,4.65-7.91,4.65c-5.96,0-10.42-4.84-10.42-12.24c0-7.45,4.47-12.29,10.42-12.29
		c4.05,0,6.7,2.33,7.77,4.7V36.61h3.86v34.25h-3.72V66.77z M446.83,58.81c0-5.31-2.61-8.89-7.17-8.89c-4.61,0-7.31,3.77-7.31,9.26
		c0,5.44,2.7,9.21,7.31,9.21c4.56,0,7.17-3.63,7.17-8.94V58.81z"
        />
        <path d="M458.52,37.87h4.38v4.7h-4.38V37.87z M458.8,47.45h3.86v23.41h-3.86V47.45z" />
        <path
          d="M474.67,51.73c1.12-2.89,4.05-4.84,7.63-4.84c5.26,0,8.38,3.3,8.38,8.89v15.08h-3.86V56.62
		c0-4.33-1.91-6.56-5.58-6.56c-3.58,0-6.42,2.28-6.42,7.91v12.89h-3.86V47.45h3.72V51.73z"
        />
        <path
          d="M515.11,65.93c-1.07,2.28-3.68,4.51-7.77,4.51c-6,0-10.38-4.51-10.38-11.82c0-7.03,4.38-11.73,10.38-11.73
		c4.1,0,6.79,2.42,7.91,4.65v-4.1h3.77v21.64c0,7.45-4.84,10.61-11.08,10.61c-5.63,0-9.45-2.28-10.38-6.84h3.91
		c0.79,2.93,3.26,3.86,6.42,3.86c4.61,0,7.21-2.47,7.21-7.35V65.93z M515.39,58.06c0-4.84-3.02-8.14-7.35-8.14
		c-4.56,0-7.26,3.49-7.26,8.7c0,5.17,2.7,8.75,7.26,8.75c4.33,0,7.35-3.35,7.35-8.19V58.06z"
        />
      </g>
    </svg>
  );
};

GreenhouseOnboardingWordmark.defaultProps = {
  size: 200,
};

export default GreenhouseOnboardingWordmark;
